module.exports = __webpack_public_path__ + "img/building.53db28a5.png";